import { TimerFormat } from './dto';
import moment from 'moment';

export function formatTimer(matchSeconds: number, timerFormat: TimerFormat) {
    if (matchSeconds == null) {
        return '';
    }
    if (timerFormat === TimerFormat.MM) {
        return `${Math.ceil(matchSeconds / 60)}'`;
    }
    if (timerFormat === TimerFormat.MM_SS) {
        const minutes = Math.floor(matchSeconds / 60);
        const seconds = Math.floor(matchSeconds % 60);
        const zeroPad = function(seconds) {
            return seconds < 10 ? '0' + seconds : '' + seconds;
        };

        return minutes + ':' + zeroPad(seconds);
    }
    return matchSeconds + 's';
}

export const formatStartTime = startTime => moment(startTime).format(' DD.MM.YYYY - H:mm');
